// extracted by mini-css-extract-plugin
export default {"inputContainer":"SearchBox_inputContainer__iHa++","MuiOutlinedInput-root":"SearchBox_MuiOutlinedInput-root__nMw1J","searchContainer":"SearchBox_searchContainer__5PsSk"};